import { render, staticRenderFns } from "./HotlineDialog.vue?vue&type=template&id=83894d50&scoped=true&"
import script from "./HotlineDialog.vue?vue&type=script&lang=js&"
export * from "./HotlineDialog.vue?vue&type=script&lang=js&"
import style0 from "./HotlineDialog.vue?vue&type=style&index=0&id=83894d50&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83894d50",
  null
  
)

export default component.exports